import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Modale Créer / Rejoindre un groupe. Props :
//  - mode : 'create' | 'join'
//  - onClose() : ferme la modale
//  - onDone(result) : appelé après succès (le parent refetch ses groupes)
export default function GroupFormModal({ mode, onClose, onDone }) {
  const [value, setValue]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [created, setCreated]   = useState(null); // { inviteCode } après création
  const token = localStorage.getItem('token');
  const isCreate = mode === 'create';

  const submit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    setLoading(true); setError('');
    try {
      if (isCreate) {
        const res = await axios.post(`${API_URL}/api/groups`, { name: value.trim() },
          { headers: { Authorization: `Bearer ${token}` } });
        setCreated(res.data);
        onDone && onDone(res.data);
      } else {
        const res = await axios.post(`${API_URL}/api/groups/join`,
          { inviteCode: value.trim().toUpperCase() },
          { headers: { Authorization: `Bearer ${token}` } });
        onDone && onDone(res.data);
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.error || (isCreate ? 'Erreur lors de la création' : 'Code invalide'));
    } finally { setLoading(false); }
  };

  return (
    <div className="invite-overlay" onClick={onClose}>
      <div className="card" onClick={e => e.stopPropagation()}
        style={{ width: 'min(420px, 92vw)', padding: 20, borderRadius: 18 }}>
        <div className="display" style={{ fontSize: 20, marginBottom: 4 }}>
          {isCreate ? 'Créer un groupe' : 'Rejoindre un groupe'}
        </div>

        {created ? (
          <>
            <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 14 }}>
              Groupe créé ! Partage ce code pour inviter tes amis :
            </p>
            <div style={{ textAlign: 'center', margin: '8px 0 18px' }}>
              <span style={{ fontSize: 26, fontWeight: 800, letterSpacing: 4, fontFamily: 'monospace', color: 'var(--sun-2)' }}>
                {created.inviteCode}
              </span>
            </div>
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={onClose}>Terminé</button>
          </>
        ) : (
          <form onSubmit={submit}>
            <p style={{ fontSize: 13, color: 'var(--text-3)', margin: '4px 0 14px' }}>
              {isCreate
                ? 'Donne un nom à ton groupe pour jouer avec tes amis.'
                : "Saisis le code d'invitation que t'a partagé un ami."}
            </p>
            <input
              type="text"
              value={value}
              onChange={e => setValue(isCreate ? e.target.value : e.target.value.toUpperCase())}
              placeholder={isCreate ? 'ex : Neptune de Nantes' : 'ex : AB12CD'}
              autoFocus
              style={{ width: '100%', padding: '12px 14px', borderRadius: 12, border: '1px solid var(--line)',
                background: 'var(--ink-2)', color: 'var(--text)', fontSize: 15, marginBottom: 12 }}
            />
            {error && <div className="message error" style={{ marginBottom: 12 }}>{error}</div>}
            <div className="row gap-2">
              <button type="button" className="btn btn-ghost" style={{ flex: 1 }} onClick={onClose}>Annuler</button>
              <button type="submit" className="btn btn-primary" style={{ flex: 1 }} disabled={loading || !value.trim()}>
                {loading ? '…' : (isCreate ? 'Créer' : 'Rejoindre')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
